import React from 'react';
import { getStatusIcon, getStatusTextFromLog } from '../utils/clientConnectorUtils';

interface Props {
  log: any;
  status: string;
}

const StatusIcon = ({ log, status }: Props) => {
  const icon = getStatusIcon(log, status);
  
  if (!icon) return null;

  // Determine color based on icon type
  const getIconColor = (iconType: string): string => {
    switch (iconType) {
      case 'check_circle':
        return '#28a745'; // Green for completed/success
      case 'warning':
        return '#ffc107'; // Yellow/amber for warnings
      case 'error':
        return '#dc3545'; // Red for errors
      case 'delete':
        return '#6c757d'; // Gray for deleted
      case 'link_off':
        return '#007bff'; // Blue for disconnected
      case 'schedule':
        return '#007bff'; // Blue for scheduled/in progress
      case 'pending':
        return '#6f42c1'; // Purple for pending
      default:
        return '#000000'; // Black as fallback
    }
  };

  return (
    <span className="ms-auto">
      <span
        className={`material-symbols-rounded user-select-none ${icon}`}
        title={getStatusTextFromLog(log)}
        style={{fontSize: '20px', color: getIconColor(icon)}}
      >
        {icon}
      </span>
    </span>
  );
};

export default StatusIcon;
